// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__2jPer","MenuToggleInner":"MenuToggle_MenuToggleInner__3HsHs","open":"MenuToggle_open__3_s88"};